import { initI18n } from '@wix/wix-i18n-config';

export function i18n(locale: string) {
  return initI18n({
    locale,
    useSuspense: true,
    asyncMessagesLoader: (localeToLoad) => {
      return import(
        `@wix/shoutout-email-translations/dist/src/locales/messages_${localeToLoad}.json`
      );
    },
  });
}
